<template>
<client-only>
  <modal name="modal-block-edit"
         transition="nice-modal-fade"
         :classes="['v--modal','block-edit-modal-box']"
         :min-width="280"
         :pivot-x="0"
         :pivot-y="0.5"
         :adaptive="true"
         :scrollable="true"
         :reset="true"
         width="440"
         height="auto"
         @closed="onClosed"
         @before-open="beforeOpen">
    <div class="modal_wrapper block-edit-modal">
      <div slot="top-right">
        <button @click="$modal.hide('modal-block-edit')" class="ngdialog-close"></button>
      </div>

      <div v-if="editCual && editCual.compo" class="colapsables">
        <!-- Header: icono del bloque + nombre -->
        <div class="block-edit-header">
          <img class="block-edit-icon" :src="blockIconSrc(editCual)" />
          <span class="block-edit-name">{{ editCual.dragLabel || editCual.nombre || editCual.compo.replace('edit','') }}</span>
        </div>

        <!-- Campos de edición del bloque (Contenido / Diseño) -->
        <component :is="editCual.compo"
                   :value="editCual"
                   @input="onChildInput"
                   :key="editCual.index + '-' + $store.state.mainComp"></component>
      </div>
    </div>
  </modal>
</client-only>
</template>

<script>
import editBoton from '@/layouts/main_Customizer/dragndrop/editBoton'
import editHTML from '@/layouts/main_Customizer/dragndrop/editHTML'
import editLine from '@/layouts/main_Customizer/dragndrop/editLine'
import editParrafo from '@/layouts/main_Customizer/dragndrop/editParrafo'
import editParrafo_new from '@/layouts/main_Customizer/dragndrop/editParrafo'
import editTitulo from '@/layouts/main_Customizer/dragndrop/editTitulo'
import editPremio from '@/layouts/main_Customizer/dragndrop/editPremio'
import editBeneficio from '@/layouts/main_Customizer/dragndrop/editBeneficio'
import editEmpty from '@/layouts/main_Customizer/dragndrop/editEmpty'
import editSpace from '@/layouts/main_Customizer/dragndrop/editSpace'
import editImagen from '@/layouts/main_Customizer/dragndrop/editImagen'
import editVideo from '@/layouts/main_Customizer/dragndrop/editVideo'
import editUbicacion from '@/layouts/main_Customizer/dragndrop/editUbicacion'
import editSocial from '@/layouts/main_Customizer/dragndrop/editSocial'
import editAvatar from '@/layouts/main_Customizer/dragndrop/editAvatar'
import editQRCode from '@/components/blocks/qrcode/settings.vue'
import editIcon from '@/components/blocks/icon/settings.vue'
import editSaveDate from '@/components/blocks/saveDate/settings.vue'
import editFlags from '@/components/blocks/flags/settings.vue'
import editLeads from '@/components/blocks/leads/settings.vue'
import { blockIconSrc } from '@/features/editor/bloques/blockIcons'

export default {
  name: 'BlockEditModal',
  data() {
    return {
      editCual: null,
    }
  },
  created() {
    // Si el modal ya esta abierto y el usuario clickea otro bloque en el preview,
    // @before-open no vuelve a dispararse. Escuchamos el bus directamente para
    // actualizar editCual: al cambiar editCual.index, el <component :key> remonta
    // el editor de cero con el bloque nuevo (sin tener que cerrar y reabrir).
    this.$bus.$on('currentCompSobreEditables', this.onSwitchBlock)
  },
  beforeDestroy() {
    this.$bus.$off('currentCompSobreEditables', this.onSwitchBlock)
  },
  methods: {
    onSwitchBlock(element) {
      this.editCual = element || null
      this.$modal.show('modal-block-edit', { element })
      if (this.$util && this.$util.isMobile()) {
         this.$bus.$emit('hideMobileMenu', true)
      }
    },
    onClosed() {
      if (this.$util && this.$util.isMobile()) {
         this.$bus.$emit('hideMobileMenu', false)
      }
    },
    blockIconSrc,
    beforeOpen(event) {
      this.editCual = (event && event.params && event.params.element) || null
    },
    onChildInput(updatedValue) {
      this.editCual = { ...this.editCual, ...updatedValue }

      let currentCard = this.$store.getters.editingLinckard
      let updatedCard = { ...currentCard }
      if (updatedCard.sobredrags) {
        updatedCard.sobredrags = [...updatedCard.sobredrags]
        if (updatedValue.arrayPosition !== undefined && updatedCard.sobredrags[updatedValue.arrayPosition]) {
          updatedCard.sobredrags[updatedValue.arrayPosition] = { ...updatedValue }
          this.$store.commit('changeActiveEdit', updatedCard)
        }
      }
    },
  },
  components: {
    'editUbicacion': editUbicacion,
    'editAvatar': editAvatar,
    'editSocial': editSocial,
    'editVideo': editVideo,
    'editImagen': editImagen,
    'editTitulo': editTitulo,
    'editPremio': editPremio,
    'editBeneficio': editBeneficio,
    'editParrafo': editParrafo,
    'editHTML': editHTML,
    'editLine': editLine,
    'editSpace': editSpace,
    'editBoton': editBoton,
    'editEmpty': editEmpty,
    'editParrafo_new': editParrafo_new,
    editQRCode,
    editIcon,
    editSaveDate,
    editFlags,
    editLeads,
  },
}
</script>

<style scoped>
.block-edit-modal {
  padding: 20px 18px 18px;
  /* Red de seguridad: el contenido nunca excede el viewport; scrollea adentro. */
  max-height: 82vh;
  overflow-y: auto;
}
/* Header: icono del bloque + nombre (sin caja, estilo imagen de referencia) */
.block-edit-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}
.block-edit-icon {
  width: 30px;
  height: 30px;
  object-fit: contain;
  flex-shrink: 0;
}
.block-edit-name {
  font-size: 20px;
  font-weight: 700;
  color: #2b3b3b;
}
</style>

<style>
@media screen and (min-width: 769px) {
  /* Caja del modal en gris claro (las secciones quedan como tarjetas blancas) */
  .block-edit-modal-box {
    background: #ededed !important;
    /* vue-js-modal posiciona con el ancho de TODA la ventana, no el del overlay
       (33.333% = la columna izquierda col-lg-4). Con pivot-x=0 queda en left:0;
       lo corremos por CSS para centrarlo dentro de esa columna sin que se desborde
       (max(0px,...) evita left negativo en pantallas angostas). */
    left: max(0px, calc((33.333vw - 440px) / 2)) !important;
  }
  /* Difumado oscuro confinado a la columna izquierda; el preview de la derecha queda visible */
  .v--modal-overlay[data-modal="modal-block-edit"] {
    width: 33.333%;
    background: rgba(0, 0, 0, 0.4);
  }
}

@media screen and (max-width: 768px) {
  .block-edit-modal-box {
    background: #ededed !important;
  }
  .v--modal-overlay[data-modal="modal-block-edit"] {
    width: 100% !important;
    background: transparent !important;
  }
}

/* Secciones Contenido / Diseño como tarjetas blancas redondeadas */
.block-edit-modal .colapsables .edicion_block {
  padding: 0 !important;
}
.block-edit-modal .colapsables .navcola {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #FFFFFF !important;
  border: 1px solid #E2E2E2 !important;
  border-radius: 12px !important;
  margin-bottom: 10px !important;
  padding: 15px 16px !important;
}
.block-edit-modal .colapsables .navcola h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #5a5a5a;
}
.block-edit-modal .colapsables .navcola .navcola-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.block-edit-modal .colapsables .navcola-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex-shrink: 0;
}
/* Header abierto: redondeado solo arriba, sin borde inferior (se conecta al panel) */
.block-edit-modal .colapsables .navcola.navcola--open {
  border-radius: 12px 12px 0 0 !important;
  border-bottom: none !important;
  margin-bottom: 0 !important;
}
/* Panel abierto: tarjeta continua debajo del header, redondeada solo abajo */
.block-edit-modal .colapsables .contenido.true {
  background: #FFFFFF !important;
  border: 1px solid #E2E2E2 !important;
  border-top: none !important;
  border-radius: 0 0 12px 12px !important;
  /* mas aire arriba/abajo para que el panel no se sienta apretado al abrir */
  padding: 18px 16px !important;
  /* anula el margin global de admin.css (.contenido.true { margin: 15px 0 0 11px }) que corria el panel */
  margin: 0 0 10px 0 !important;
}
</style>
